var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"uploadImgBtn customBtn"},[_c('UploadImgIcon'),_c('span',{staticClass:"load f14"},[_vm._v(_vm._s(_vm.text)),(_vm.accept)?_c('span',{staticClass:"accept"},[_vm._v("JPEG, PNG")]):_vm._e()]),_c('input',{staticClass:"fileInput",attrs:{"type":"file","accept":".jpg, .jpeg, .png"},on:{"change":_vm.handleFileUpload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }